import { Route, Switch } from "react-router";
import { BrowserRouter as Router } from "react-router-dom";
import "./App.css";
import BookRide from "./Components/BookRide/BookRide";
import Home from "./Components/Home/Home";
import Login from "./Components/Login/Login";
import NavigationBar from "./Components/NavigationBar/NavigationBar";
import CannotFound from "./Components/CannotFound/CannotFound";
import { createContext, useState } from "react";
import PrivateRoute from "./Components/PrivateRoute/PrivateRoute";
export const UserContext = createContext();

function App() {
  const [user, setUser] = useState({});
  const [whichVehicle, setWhichVehicle] = useState({});
  return (
    <UserContext.Provider
      value={[user, setUser, whichVehicle, setWhichVehicle]}
    >
      <Router>
        <NavigationBar />
        <Switch>
          <Route path="/home">
            <Home />
          </Route>
          <Route path="/login">
            <Login />
          </Route>
          <PrivateRoute path="/book-ride">
            <BookRide />
          </PrivateRoute>
          <Route exact path="/">
            <Home />
          </Route>
          <Route path="*">
            <CannotFound></CannotFound>
          </Route>
        </Switch>
      </Router>
    </UserContext.Provider>
  );
}

export default App;
